// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader-module--header--d6bec","close":"ModalHeader-module--close--d8fea"};